<div class="user-profile-settings-container no-select">

  <div class="widget-div">
    @if (canUserProfileDetailsBeViewed || canUserPersonalDetailsBeViewed || canUserContactDetailsBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [icon]="icons.account">
          </app-display-icon>
          <div>User Profile</div>
        </div>
        <div block>
          @if (canUserProfileDetailsBeViewed) {
            <form [formGroup]="formProfileDetails">
              <div class="form-column">
                @if (formProfileDetails?.controls['pp']) {
                  <div
                    class="form-control-div"
                    (mouseenter)="isHoveringProfileImage =  true"
                    (mouseleave)="isHoveringProfileImage = false"
                    (click)="onChangeProfilePictureClick()">
                    <label>Profile Picture</label>
                    <input [formControlName]="'pp'" hidden/>
                    <input
                      (change)="onProfilePictureChange($event)"
                      hidden
                      id="changeProfileImage"
                      type="file">
                    @if (!!formProfileDetails?.controls['pp'].value) {
                      @if (isHoveringProfileImage && canUserProfileDetailsBeEdited === true) {
                        <div class="placeholder-profile">

                          <app-display-icon
                            [colour]="iconColours.primary"
                            [icon]="isHoveringProfileImage && canUserProfileDetailsBeEdited === true
                            ? icons.cameraOutline : icons.account">
                          </app-display-icon>
                        </div>
                      } @else {
                        <img
                          [src]="formProfileDetails?.controls['pp']?.value"
                          alt="User Profile Details - Profile Picture"
                          class="profile-picture">
                      }
                    } @else {
                      <div class="placeholder-profile">
                        {{ getInitials }}
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="form-column min-width ">
                @if (formProfileDetails?.controls['username']) {
                  <div class="form-control-div">
                    <label for="username" class="required-field">Username</label>
                    <input
                      [class.invalid]="formProfileDetails?.controls['username']?.errors"
                      [formControlName]="'username'"
                      id="username"
                      type="text"/>
                  </div>
                }
                <div class="form-control-div">
                  <label>Forgot Password</label>
                  <app-shared-button
                    (click)="onResetPassword()"
                    [colour]="'secondary'">
                    <div>Reset Password</div>
                  </app-shared-button>
                </div>
                <div class="form-control-div">
                  <label>Change Password</label>
                  <app-shared-button
                    (click)="onShowChangePasswordForm()"
                    [colour]="'secondary'">
                    <div>Change Password</div>
                  </app-shared-button>
                </div>
              </div>
            </form>
          }

          @if (canUserPersonalDetailsBeViewed) {
            <form [formGroup]="formPersonalDetails">
              <div class="form-column min-width first-last-name-fields">
                @if (formPersonalDetails?.controls['firstname']) {
                  <div class="form-control-div">
                    <label for="firstname">First Name</label>
                    <input
                      [class.invalid]="formPersonalDetails?.controls['firstname']?.errors"
                      [formControlName]="'firstname'"
                      id="firstname"
                      type="text"/>
                  </div>
                }
                @if (formPersonalDetails?.controls['lastname']) {
                  <div class="form-control-div">
                    <label for="lastname">Last Name</label>
                    <input
                      [class.invalid]="formPersonalDetails?.controls['lastname']?.errors"
                      [formControlName]="'lastname'"
                      id="lastname"
                      type="text"/>
                  </div>
                }
              </div>
            </form>
          }

          @if (canUserContactDetailsBeViewed) {
            <form [formGroup]="formContactDetails">
              <div class="form-column min-width contact-details-fields">

                @if (formContactDetails?.controls['cellphone']) {
                  <div class="form-control-div">
                    <label for="contactNumber">Contact Number</label>
                    <input
                      [class.invalid]="formContactDetails.controls['cellphone']?.errors"
                      [formControlName]="'cellphone'"
                      id="contactNumber"
                      type="tel"/>
                  </div>
                }

                @if (formContactDetails?.controls['email']) {
                  <div class="form-control-div">
                    <label for="email">Email Address</label>
                    <input
                      [class.invalid]="formContactDetails.controls['email']?.errors"
                      [formControlName]="'email'"
                      id="email"
                      type="email"/>
                  </div>
                }
              </div>
            </form>
          }

        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasUserProfileDetailsErrors?.length > 0) {
            @for (field of hasUserProfileDetailsErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]=" iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
          @if (hasUserContactDetailsErrors?.length > 0) {
            @for (field of hasUserContactDetailsErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]=" iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
        </div>
      </app-shared-widget-container-component>
    }

    @if (canChangePasswordBeViewed && isChangePasswordFormVisible) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canChangePasswordBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canChangePasswordBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Change Password</div>
        </div>
        <div block>
          <form [formGroup]="formChangePassword">

            <div class="form-column min-width">
              @if (formChangePassword?.controls['currentPassword']) {
                <div class="form-control-div">
                  <label for="currentPassword" class="required-field">Current Password</label>
                  <input
                    [class.invalid]="formChangePassword?.controls['currentPassword']?.errors"
                    [formControlName]="'currentPassword'"
                    id="currentPassword"
                    type="password"
                    autocomplete="current-password"/>
                </div>
              }
              @if (formChangePassword?.controls['newPassword']) {
                <div class="form-control-div">
                  <label for="newPassword" class="required-field">New Password</label>
                  <input
                    [class.invalid]="formChangePassword?.controls['newPassword']?.errors"
                    [formControlName]="'newPassword'"
                    id="newPassword"
                    type="password"
                    autocomplete="new-password"/>
                  @if (formChangePassword?.controls['newPassword']?.touched || formChangePassword?.controls['newPassword']?.dirty) {
                    <div class="password-requirements">
                      <small>Password must contain:</small>
                      <small [class.requirement-met]="!formChangePassword?.controls['newPassword']?.errors?.['minlength']">• At least 8 characters</small>
                      <small [class.requirement-met]="!formChangePassword?.controls['newPassword']?.errors?.['requiresUppercase']">• One uppercase letter</small>
                      <small [class.requirement-met]="!formChangePassword?.controls['newPassword']?.errors?.['requiresLowercase']">• One lowercase letter</small>
                      <small [class.requirement-met]="!formChangePassword?.controls['newPassword']?.errors?.['requiresDigit']">• One number</small>
                      <small [class.requirement-met]="!formChangePassword?.controls['newPassword']?.errors?.['requiresSpecialChar']">• One special character (!@#$%^&*)</small>
                    </div>
                  }
                </div>
              }
              @if (formChangePassword?.controls['confirmNewPassword']) {
                <div class="form-control-div">
                  <label for="confirmNewPassword" class="required-field">Confirm New Password</label>
                  <input
                    [class.invalid]="formChangePassword?.controls['confirmNewPassword']?.errors || formChangePassword?.errors?.['passwordMismatch']"
                    [formControlName]="'confirmNewPassword'"
                    id="confirmNewPassword"
                    type="password"
                    autocomplete="new-password"/>
                </div>
              }
            </div>

          </form>
        </div>
        <div actions class="widget-actions">
          <button
            type="button"
            class="action-button close"
            (click)="onCancelChangePassword()">
            <app-display-icon
              [colour]="iconColours.secondary"
              [tooltip]="'Cancel'"
              [icon]="icons.close">
            </app-display-icon>
          </button>
          @if (hasChangePasswordBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canChangePasswordBeEdited === false"
              (click)="onRevertForm('changePassword')">
              <app-display-icon
                [colour]="canChangePasswordBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canChangePasswordBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isChangePasswordSubmitDisabled"
              (click)="onChangePassword()">
              <app-display-icon
                [colour]="isChangePasswordSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
          @if (hasChangePasswordErrors?.length > 0) {
            @for (field of hasChangePasswordErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]="iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
        </div>
      </app-shared-widget-container-component>
    }
  </div>

  <div class="ups-container-action-bar widget-actions">
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save Profile Settings
      </button>
  </div>

</div>
